import React, { useCallback, useEffect, useState } from 'react';
import { useParams, useOutletContext, Link } from 'react-router-dom';
import './MyAccountOrderTreatmentInstructions.css';
import * as translator from '../../../../utils/translator';
import MyAccountContentHeader from '../MyAccountContentHeader/MyAccountContentHeader';
import * as http from '../../../../utils/http';

type OrderData = {
	cartView: any;
	orderDate: string;
	status: string;
};

const MyAccountOrderTreatmentInstructions = () => {
	const { setError, setLoading, country, language } = useOutletContext<any>();
	const { order_hash_id: hashID } = useParams();
	const [orderData, setOrderData] = useState<OrderData | null>(null);

	useEffect(() => {
		window.scrollTo(0, 0);
		setLoading(true);
		http
			.getFromServer(`${country}/account/orders/${hashID}/treatment-instructions`, [http.MIDDLEWARES.CUSTOMER_ID])
			.then((response) => {
				setOrderData(response.data);
			})
			.catch((error) => {
				window.clientLogger.error('Error in MyAccountOrderTreatmentInstructions: ', error);
				setError(500);
			})
			.finally(() => {
				setLoading(false);
			});
	}, []);

	const parseTreatmentTitle = useCallback(
		(productTitle: string) => {
			let instructionsTitle = translator.translate(language, 'my_account', 'MyOrders/instructionsTitle');
			return instructionsTitle.replace(':shortTitle', productTitle);
		},
		[language]
	);

	if (!hashID || !country) {
		return setError(400);
	}

	if (!orderData) {
		return <></>;
	}

	return (
		<>
			<div className="account-content">
				<MyAccountContentHeader title={translator.translate(language, 'my_account', 'MyOrders/cardInstructions')} description={''} />
				<div className="orders-list orders-item__info ">
					<div className="orders-info">
						<div className="orders-info__row">
							<div className="orders-info__col">
								<div className="orders-info__title">{translator.translate(language, 'my_account', 'MyOrders/cardHashID')}</div>
								<div className="orders-info__item">{hashID}</div>
							</div>
							<div className="orders-info__col">
								<div className="orders-info__title">{translator.translate(language, 'my_account', 'MyOrders/cardDateTime')}</div>
								<div className="orders-info__item">{orderData.orderDate}</div>
							</div>
							<div className="orders-info__col">
								<div className="orders-info__title">{translator.translate(language, 'my_account', 'MyOrders/cardStatus')}</div>
								<div className="orders-info__item">{translator.translate(language, 'my_account', `MyOrders/status/${orderData.status}`)}</div>
							</div>
						</div>

						<div className="treatment-instructions-links">
							<Link to={`/${country}/account/my-orders/${hashID}/prescription`} className="account-order-card-link">
								{translator.translate(language, 'my_account', 'MyOrders/cardQuestionnaire')}
							</Link>
							<Link to={`/${country}/account/my-orders/${hashID}/details`} className="account-order-card-link">
								{translator.translate(language, 'my_account', 'MyOrders/cardDetails')}
							</Link>
						</div>
					</div>
				</div>
				<div className="order-products-container">
					{orderData?.cartView?.products?.map((product: any) => (
						<div className="order-product">
							<div className="orders-list">
								<div className="orders-item__image">
									<img className="item__image" src={product.imageSrc}></img>
								</div>
								<div className="orders-item__description">
									<div className="description-wrapper">
										<h6 className="orders-name">{product.quantity + ' X ' + product.title + ' ' + product.quantityStr}</h6>
									</div>
								</div>
							</div>
							<div className="treatment-instructions__wrap">
								<p className="treatment-instructions__title">{parseTreatmentTitle(product.title)}</p>
								<p className="treatment-instructions__description">{product.application_notes}</p>
							</div>
						</div>
					))}
				</div>
			</div>
		</>
	);
};

export default MyAccountOrderTreatmentInstructions;
